
import { Link } from 'react-router-dom';

export default function MedicineNotWorking() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Article Header */}
      <section className="py-16 bg-gradient-to-br from-red-50 to-orange-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-teal-600 font-semibold">ビースト君</p>
                <p className="text-gray-500 text-sm">2025年10月6日</p>
              </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">薬が効かないときの原因5選｜飲み方・生活習慣・相互作用をチェック</h1>
            <p className="text-xl text-gray-600">薬の効果が感じられない時に確認すべきポイントを薬剤師が詳しく解説します</p>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/909c826f1b50f16792536a6cfab29a60.jpg"
              alt="薬が効かない原因の解説"
              className="w-full max-w-2xl h-80 object-cover object-top rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-700 mb-8">
              こんにちは、ビースト君です！「薬を飲んでいるのに効果が感じられない」という相談をよく受けます。
              筋トレでも正しいフォームでやらないと効果が出ないように、薬も正しく使わないと効果が現れません。
              今日は薬が効かない時の主な原因5つについて詳しく解説します。
            </p>

            <div className="bg-red-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-red-800 mb-4">⚠️ 重要な注意点</h3>
              <p className="text-gray-700">
                薬の効果が感じられない場合は、自己判断で薬を中止したり量を変えたりせず、
                必ず医師や薬剤師に相談してください。病気の悪化や副作用のリスクがあります。
              </p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">薬が効かない主な原因5選</h2>
            
            <div className="space-y-8 mb-12">
              {/* 原因1 */}
              <div className="bg-blue-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-blue-800 mb-4 flex items-center">
                  <span className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">1</span>
                  服用方法・タイミングの間違い
                </h3>
                <p className="text-gray-700 mb-4">
                  筋トレでも正しいタイミングが大切なように、薬も正しい服用方法とタイミングが効果に大きく影響します。
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">❌ よくある間違い</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 食前薬を食後に服用</li>
                      <li>• 空腹時薬を食事と一緒に服用</li>
                      <li>• 服用時間がバラバラ</li>
                      <li>• 水以外の飲み物で服用</li>
                      <li>• 薬を噛み砕いて服用</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">✅ 正しい対処法</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 処方箋の指示を厳守</li>
                      <li>• 毎日同じ時間に服用</li>
                      <li>• コップ1杯の水で服用</li>
                      <li>• 薬剤師に服用方法を確認</li>
                      <li>• お薬手帳で記録管理</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 原因2 */}
              <div className="bg-green-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-green-800 mb-4 flex items-center">
                  <span className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">2</span>
                  服用期間が不十分
                </h3>
                <p className="text-gray-700 mb-4">
                  筋トレの効果が出るまで時間がかかるように、薬の効果も即座に現れるとは限りません。
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⏰ 薬の種類別効果発現時間</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• <strong>抗うつ薬：</strong>2-4週間</li>
                      <li>• <strong>血圧降下薬：</strong>1-2週間</li>
                      <li>• <strong>糖尿病薬：</strong>数日-2週間</li>
                      <li>• <strong>抗生物質：</strong>2-3日</li>
                      <li>• <strong>痛み止め：</strong>30分-2時間</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">💡 重要なポイント</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 効果が出るまで継続服用</li>
                      <li>• 症状日記をつける</li>
                      <li>• 定期的な検査で効果確認</li>
                      <li>• 医師との定期的な相談</li>
                      <li>• 自己判断での中止は禁物</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 原因3 */}
              <div className="bg-purple-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-purple-800 mb-4 flex items-center">
                  <span className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">3</span>
                  食事・飲み物との相互作用
                </h3>
                <p className="text-gray-700 mb-4">
                  筋トレ前後の食事が効果に影響するように、薬も食事や飲み物との組み合わせで効果が変わります。
                </p>
                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🥛 注意が必要な飲み物</h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">グレープフルーツジュース</h5>
                        <p className="text-gray-600 text-sm">血圧薬、コレステロール薬の効果を強めすぎる</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">牛乳・乳製品</h5>
                        <p className="text-gray-600 text-sm">抗生物質の吸収を阻害する</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">お茶・コーヒー</h5>
                        <p className="text-gray-600 text-sm">鉄剤の吸収を妨げる</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">アルコール</h5>
                        <p className="text-gray-600 text-sm">多くの薬で相互作用あり</p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🍽️ 食事のタイミング</h4>
                    <div className="grid md:grid-cols-3 gap-4">
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">食前服用薬</h5>
                        <p className="text-gray-600 text-sm">胃酸分泌抑制薬、糖尿病薬など</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">食後服用薬</h5>
                        <p className="text-gray-600 text-sm">NSAIDs、ステロイドなど</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">食間服用薬</h5>
                        <p className="text-gray-600 text-sm">漢方薬、一部の抗生物質など</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 原因4 */}
              <div className="bg-orange-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-orange-800 mb-4 flex items-center">
                  <span className="bg-orange-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">4</span>
                  他の薬・サプリメントとの相互作用
                </h3>
                <p className="text-gray-700 mb-4">
                  筋トレでも複数の種目を組み合わせる時に注意が必要なように、複数の薬を飲む時も相互作用に注意が必要です。
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">💊 薬同士の相互作用例</h4>
                    <ul className="text-gray-600 text-sm space-y-2">
                      <li>• <strong>ワルファリン × 抗生物質：</strong>出血リスク増加</li>
                      <li>• <strong>降圧薬 × NSAIDs：</strong>血圧降下効果減弱</li>
                      <li>• <strong>抗うつ薬 × 胃薬：</strong>抗うつ薬の効果減弱</li>
                      <li>• <strong>糖尿病薬 × ステロイド：</strong>血糖コントロール悪化</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🌿 サプリメントとの相互作用</h4>
                    <ul className="text-gray-600 text-sm space-y-2">
                      <li>• <strong>セントジョーンズワート：</strong>多くの薬の効果を減弱</li>
                      <li>• <strong>ビタミンK：</strong>ワルファリンの効果を阻害</li>
                      <li>• <strong>カルシウム：</strong>抗生物質の吸収阻害</li>
                      <li>• <strong>鉄分：</strong>甲状腺ホルモン薬の吸収阻害</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">✅ 対策方法</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• お薬手帳を必ず持参</li>
                    <li>• サプリメントも含めて全て報告</li>
                    <li>• 市販薬購入時も薬剤師に相談</li>
                    <li>• 複数の医療機関受診時は薬の情報を共有</li>
                  </ul>
                </div>
              </div>

              {/* 原因5 */}
              <div className="bg-indigo-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-indigo-800 mb-4 flex items-center">
                  <span className="bg-indigo-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">5</span>
                  生活習慣・体質の影響
                </h3>
                <p className="text-gray-700 mb-4">
                  筋トレの効果が人によって違うように、薬の効果も個人の生活習慣や体質によって大きく左右されます。
                </p>
                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚬 生活習慣の影響</h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">喫煙</h5>
                        <p className="text-gray-600 text-sm">多くの薬の代謝を促進し、効果を減弱させる</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">飲酒</h5>
                        <p className="text-gray-600 text-sm">肝臓での薬物代謝に影響を与える</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">睡眠不足</h5>
                        <p className="text-gray-600 text-sm">薬の吸収・代謝に悪影響</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">ストレス</h5>
                        <p className="text-gray-600 text-sm">胃腸機能低下により吸収不良</p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🧬 体質・個人差の要因</h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">代謝酵素の個人差</h5>
                        <p className="text-gray-600 text-sm">薬を分解する酵素の活性に個人差</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">年齢による変化</h5>
                        <p className="text-gray-600 text-sm">加齢により薬の代謝・排泄能力が低下</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">腎機能・肝機能</h5>
                        <p className="text-gray-600 text-sm">臓器機能低下により薬の処理能力が変化</p>
                      </div>
                      <div>
                        <h5 className="font-medium text-gray-800 mb-1">体重・体格</h5>
                        <p className="text-gray-600 text-sm">薬の分布や効果に影響</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">薬が効かない時の対処法</h2>
            
            <p className="text-gray-700 mb-6">
              薬の効果が感じられない時は、以下のステップで対処しましょう。
              筋トレでも効果が出ない時は方法を見直すように、薬も適切な対処が必要です。
            </p>

            <div className="bg-teal-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-teal-800 mb-4">対処法のステップ</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4 flex items-start">
                  <div className="bg-teal-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-4 mt-1">1</div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">服用状況の確認</h4>
                    <p className="text-gray-600 text-sm">正しい服用方法、タイミング、期間を再確認する</p>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 flex items-start">
                  <div className="bg-teal-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-4 mt-1">2</div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">薬剤師への相談</h4>
                    <p className="text-gray-600 text-sm">服用方法や相互作用について専門的なアドバイスを受ける</p>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 flex items-start">
                  <div className="bg-teal-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-4 mt-1">3</div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">医師への報告</h4>
                    <p className="text-gray-600 text-sm">効果不十分の状況を詳しく医師に伝える</p>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 flex items-start">
                  <div className="bg-teal-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-4 mt-1">4</div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">治療方針の見直し</h4>
                    <p className="text-gray-600 text-sm">薬の変更、用量調整、併用薬の検討など</p>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 flex items-start">
                  <div className="bg-teal-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-4 mt-1">5</div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">生活習慣の改善</h4>
                    <p className="text-gray-600 text-sm">禁煙、節酒、規則正しい生活リズムの確立</p>
                  </div>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">症状記録のすすめ</h2>
            
            <p className="text-gray-700 mb-6">
              筋トレでトレーニング記録をつけるように、薬の効果も記録することが大切です。
              医師や薬剤師との相談時に役立つ情報になります。
            </p>

            <div className="bg-blue-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-blue-800 mb-4">記録すべき項目</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">📝 服薬記録</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• 服用日時</li>
                    <li>• 服用した薬の種類・量</li>
                    <li>• 飲み忘れの有無</li>
                    <li>• 服用時の食事状況</li>
                    <li>• 一緒に飲んだ他の薬・サプリ</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">📊 症状記録</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• 症状の程度（10段階評価など）</li>
                    <li>• 症状の変化</li>
                    <li>• 副作用の有無</li>
                    <li>• 体調の変化</li>
                    <li>• 生活習慣の変化</li>
                  </ul>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">よくある質問と回答</h2>
            
            <div className="bg-gray-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Q&A</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: 薬が効かない時、勝手に量を増やしても良いですか？</h4>
                  <p className="text-gray-600 text-sm">A: 絶対にやめてください。副作用のリスクが高まります。必ず医師に相談して適切な用量調整を受けてください。</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: ジェネリック医薬品に変えたら効かなくなった気がします</h4>
                  <p className="text-gray-600 text-sm">A: 添加物の違いや心理的要因の可能性があります。薬剤師に相談し、必要に応じて先発品に戻すことも検討しましょう。</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: 効果が出るまでどのくらい待てば良いですか？</h4>
                  <p className="text-gray-600 text-sm">A: 薬の種類によって異なります。抗生物質は2-3日、抗うつ薬は2-4週間が目安です。医師に確認しましょう。</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: サプリメントも薬の効果に影響しますか？</h4>
                  <p className="text-gray-600 text-sm">A: はい、影響する場合があります。サプリメントも含めて全て医師・薬剤師に報告してください。</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: 薬が効かない場合、病気が悪化しているのでしょうか？</h4>
                  <p className="text-gray-600 text-sm">A: 必ずしもそうではありません。服用方法や相互作用が原因の場合も多いです。まずは薬剤師・医師に相談しましょう。</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">まとめ</h2>
            
            <p className="text-gray-700 mb-6">
              薬が効かない原因は様々ですが、多くの場合は適切な対処により改善できます。
              筋トレでも正しい方法を身につけることで効果が出るように、薬も正しい知識と使い方が重要です。
            </p>

            <div className="bg-teal-50 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-teal-800 mb-4">ビースト君からのアドバイス</h3>
              <p className="text-gray-700">
                薬が効かない時は焦らず、まず原因を冷静に分析しましょう。筋トレでも効果が出ない時は
                フォームや方法を見直すように、薬も服用方法や生活習慣を見直すことが大切です。
                一人で悩まず、薬剤師や医師に相談することで、きっと解決策が見つかります。
                正しい知識と適切な対処で、薬の効果を最大限に引き出しましょう！💪💊
              </p>
            </div>
          </div>
        </div>
      </article>

      {/* Related Articles */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">関連記事</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <Link to="/beast-blog/effective-medication" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20medicine%20timing%20and%20proper%20medication%20usage%2C%20educational%20illustration%20with%20clock%20and%20medicine%20schedule%2C%20friendly%20cartoon%20style%2C%20professional%20healthcare%20setting&width=400&height=250&seq=beast-medication-timing-related&orientation=landscape"
                alt="薬の効果的な飲み方"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">薬の効果的な飲み方とタイミング</h3>
                <p className="text-gray-600">薬の効果を最大限に引き出すための正しい服用方法について解説します</p>
              </div>
            </Link>
            <Link to="/beast-blog/generic-medicine" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20generic%20medicines%20and%20pharmaceutical%20differences%2C%20educational%20illustration%20with%20medicine%20bottles%20and%20comparison%20charts%2C%20friendly%20cartoon%20style%2C%20professional%20pharmacy%20setting&width=400&height=250&seq=beast-generic-medicine-related&orientation=landscape"
                alt="ジェネリック医薬品"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">ジェネリック医薬品とは？違い・メリット・デメリットを薬剤師が解説</h3>
                <p className="text-gray-600">先発医薬品との違いやオーソライズドジェネリックについても詳しく解説</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">ビースト君ブログ</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/beast-blog" className="hover:text-white cursor-pointer">記事一覧</Link></li>
                <li><Link to="/beast-blog/multidisciplinary-collaboration" className="hover:text-white cursor-pointer">多職種連携</Link></li>
                <li><Link to="/beast-blog/winter-mental-health" className="hover:text-white cursor-pointer">メンタルヘルス</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
